import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box, Grid, Typography } from '@material-ui/core'

import { DashboardChartPaper, DashboardTable } from 'components'

import theme from 'theme'
import useStyles from './styles'
import constants from 'constants/index'

const LegalFramework = ({ isLoading = false, legalFramework = {} }) => {
  const classes = useStyles()

  const { LEGAL_FRAMEWORK_TABLE } = constants.dataIntelligence

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Typography variant="h5" color="primary">
        Enquadramento legal
      </Typography>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardChartPaper
            title="Bases legais"
            subtitle="Bases legais dos agentes de tratamento"
            noMaxHeight
          >
            <DashboardTable
              emptyMessage="Nenhum enquadramento legal encontrado."
              rows={legalFramework?.national}
              columns={LEGAL_FRAMEWORK_TABLE}
              isLoading={isLoading}
            />
          </DashboardChartPaper>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardChartPaper
            title="Bases legais internacionais"
            subtitle="Bases legais internacionais dos agentes de tratamento"
            noMaxHeight
          >
            <DashboardTable
              emptyMessage="Nenhum enquadramento legal encontrado."
              rows={legalFramework?.international}
              columns={LEGAL_FRAMEWORK_TABLE}
              isLoading={isLoading}
            />
          </DashboardChartPaper>
        </Grid>
      </Grid>
    </Box>
  )
}

LegalFramework.propTypes = {
  isLoading: PropTypes.bool,
  legalFramework: PropTypes.object,
}

export default LegalFramework
